module.exports = __webpack_public_path__ + "media/images/new-ui-images/blue-pdf-3de3cf5bbcc3fe8abd3adb41e7db67e8.svg";